/**
 * One loading convention for the whole portal:
 *
 *   value on its way      →  <Skeleton />, which is visibly busy
 *   value genuinely absent →  an em dash
 *
 * They used to share the em dash — a loading metric tile and an empty one were
 * indistinguishable — while table bodies rendered nothing at all during a load,
 * so a header sat over blank space with no indication anything was happening.
 */
export function Skeleton({ width, height, radius }: { width?: string; height?: string; radius?: string }) {
  return <span className="skeleton" style={{ width, height, borderRadius: radius }} aria-hidden="true" />;
}

/**
 * Varied but deterministic widths: random ones would reshuffle on every render,
 * and identical ones read as a rendering bug rather than as pending content.
 */
const CELL_WIDTHS = ["72%", "48%", "63%", "55%", "68%", "43%", "76%", "51%"];

export function SkeletonRows({ rows = 6, columns }: { rows?: number; columns: number }) {
  return <>
    {Array.from({ length: rows }, (_, row) => (
      <tr key={row} className="skeleton-row">
        {Array.from({ length: columns }, (_, column) => (
          <td key={column}><Skeleton width={CELL_WIDTHS[(row * columns + column) % CELL_WIDTHS.length]} /></td>
        ))}
      </tr>
    ))}
  </>;
}
